import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* pointSystemsWatchers() {
  yield all([
    takeEvery(EntryActionTypes.POINT_SYSTEM_IN_CURRENT_BOARD_UPDATE, ({ payload: { isEnabled } }) =>
      services.updatePointSystemInCurrentBoard(isEnabled),
    ),
    takeEvery(EntryActionTypes.POINT_SYSTEM_MODAL_OPEN_IN_CURRENT_BOARD, () =>
      services.openPointSystemModalInCurrentBoard(),
    ),
  ]);
}
